import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import {
  useCurrentDataLayerTypeSelector,
  useCurrentGeoRasterDataSelector,
  useSelectedRecommendedProjectSelector,
} from "../../../../store/projects/selectors";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

type ChartData = {
  labels: string[];
  values: number[];
};

const ReLandUseAccordionBody = () => {
  const class_legends: any = {
    1: "Water",
    2: "Trees",
    4: "Flooded vegetation",
    5: "Crops",
    7: "Built Area",
    8: "Bare ground",
    9: "Snow/Ice",
    10: "Clouds",
    11: "Rangeland",
  };

  const selectedReProject = useSelectedRecommendedProjectSelector();
  const geoRasterData = useCurrentGeoRasterDataSelector();
  const currentLayer = useCurrentDataLayerTypeSelector();

  const [chartData, setChartData] = useState<ChartData>({
    labels: [],
    values: [],
  });

  useEffect(() => {
    if (currentLayer === "lulc" && geoRasterData) {
      processChartData(geoRasterData?.data);
    }
  }, [selectedReProject, geoRasterData]);

  const processChartData = async (geoRasterData: any) => {
    let pixelArea: number;
    if (geoRasterData.pixelHeight && geoRasterData.pixelWidth) {
      pixelArea = geoRasterData.pixelHeight * 100000 * (geoRasterData.pixelWidth * 100000);
      const values = geoRasterData.values[0];
      const pixelAreaHectares = pixelArea / 10000;

      const landUseData: Record<string, number> = {};
      Object.keys(class_legends).forEach((key: any) => {
        landUseData[class_legends[key]] = 0;
      });

      for (let y = 0; y < geoRasterData.height; y++) {
        for (let x = 0; x < geoRasterData.width; x++) {
          const pixelValue = values[y][x];
          if (class_legends[pixelValue]) {
            const landType = class_legends[pixelValue];
            landUseData[landType] += pixelAreaHectares;
          }
        }
      }

      const labels = Object.keys(landUseData);
      const dataValues = labels.map((label) => landUseData[label]);

      setChartData({
        labels: labels,
        values: dataValues,
      });
    } else {
      console.error("Insufficient data to calculate the area");
    }
  };

  const options = {
    plugins: {
      title: {
        display: false,
        text: "lulc",
      },
      legend: {
        display: false,
        position: "bottom" as const,
      },
    },
    responsive: true,
    interaction: {
      mode: "index" as const,
      intersect: false,
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "land use type",
        },
        grid: {
          display: false,
        },
      },
      y: {
        title: {
          display: true,
          text: "Area(Hectares)",
        },
        grid: {
          display: true,
        },
      },
    },
  };

  const data = {
    labels: chartData.labels,
    datasets: [
      {
        label: "Land Use",
        data: chartData?.values,
        backgroundColor: [
          "blue",
          "green",
          "orange",
          "red",
          "purple",
          "brown",
          "cyan",
          "gray",
          "olive",
        ],
        barThickness: 35,
        barPercentage: 0.5,
      },
    ],
  };

  return (
    <div className="font-primary">
      <div>
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default ReLandUseAccordionBody;
